var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.classes,style:(_vm.styles)},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }